import React from 'react';

/**
 * SettingsViewTabs - Toggle between "Account" and "Schedules" views
 * Matches the pattern used in Dashboard, Polls, Watchlists tabs
 */
const SettingsViewTabs = ({ 
  settingsView, 
  setSettingsView 
}) => {
  return (
    <div className="flex items-center bg-black/20 rounded-lg p-1">
      <button
        onClick={() => setSettingsView('account')}
        data-testid="settings-account-tab"
        className={`flex-1 sm:flex-none px-3 py-1 text-xs sm:text-sm font-medium rounded transition-all duration-200 ${
          settingsView === 'account' 
            ? 'bg-white text-slate-800 shadow-sm' 
            : 'text-white/70 hover:text-white'
        }`}
      >
        Account
      </button>
      <button
        onClick={() => setSettingsView('schedules')}
        data-testid="settings-schedules-tab"
        className={`flex-1 sm:flex-none px-3 py-1 text-xs sm:text-sm font-medium rounded transition-all duration-200 ${
          settingsView === 'schedules' 
            ? 'bg-white text-slate-800 shadow-sm' 
            : 'text-white/70 hover:text-white'
        }`}
      >
        Schedules
      </button>
    </div>
  );
};

export default SettingsViewTabs;
